import { Injectable } from '@angular/core';
import { RmsService } from './rms.service';
import { Observable } from 'rxjs/internal/Observable';
import { map } from 'rxjs/operators';

enum Mode {
  GET = 'get',
  SET = 'set'
}

export enum Scope {
  GLOBAL = 'global',
  USER = 'user'
}

interface Request {
  Mode: Mode;
  Key: string;
  Scope: Scope;
  Value: string;
}

interface Response {
  Succeed: boolean;
  Value: string;
}

@Injectable({
  providedIn: 'root'
})
export class CachingService {

  constructor(
    private rms: RmsService) { }

  private get service(): string {
    return this.rms.isLoggedIn ? "rms.common.cache" : "rms.common.cache.public";
  }

  public get(key: string, defaultValue: any = null, scope: Scope = Scope.GLOBAL): Observable<any> {

    return this.rms.request<Request, Response>({
      service: this.service,
      data: {
        Mode: Mode.GET,
        Key: key,
        Scope: scope,
        Value: null
      }
    }).pipe(map((response) => {

      if (response.succeed && response.data.Succeed == true) {

        try {
          return JSON.parse(response.data.Value);
        }
        catch (e) {
          return defaultValue;
        }
      }

      return defaultValue;

    }));
  }

  public set(key: string, value: any, scope: Scope = Scope.GLOBAL): Observable<boolean> {

    return this.rms.request<Request, Response>({
      service: this.service,
      data: {
        Mode: Mode.SET,
        Key: key,
        Scope: scope,
        Value: JSON.stringify(value)
      }
    }).pipe(map((response) => response.succeed && response.data.Succeed == true));
  }
}
